export default __webpack_public_path__ + "static/media/descending-deactive.228806cd.svg";